<template>
  <div class="tab-content">
    <div class="mb-4">
      <h2 class="mb-2">SEO</h2>
      <div class="mb-3">
        <va-input
          v-model.trim="formData.meta_title"
          placeholder="Meta Title"
          class="mb-0"
        />
      </div>
      <div>
        <va-input
          v-model.trim="formData.meta_description"
          type="textarea"
          class="mb-0"
          :min-rows="2"
          :max-rows="3"
          placeholder="Meta Description"
        />
      </div>
    </div>
    <div class="mb-4">
      <h2 class="mb-2">Информация о доставке</h2>
      <va-input
        v-model.trim="formData.delivery_info"
        type="textarea"
        class="mb-0"
        :min-rows="2"
        :max-rows="4"
        placeholder="Информация о доставке"
      />
    </div>
    <div class="mb-4">
      <h2 class="mb-2">Информация об оплате</h2>
      <va-input
        v-model.trim="formData.payment_info"
        type="textarea"
        class="mb-0"
        :min-rows="2"
        :max-rows="4"
        placeholder="Информация об оплате"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductFormTabSeo",
  props: {
    formData: { type: Object, required: true },
  },
};
</script>

<style scoped>
.tab-content {
  grid-column: 1 / -1;
}
</style>
